"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HorizontalComponent = exports.GroupComponent = void 0;
const BaseComponent_1 = require("./BaseComponent");
/**
 * 分组容器组件
 * 提供带标题的分组布局功能
 */
class GroupComponent extends BaseComponent_1.BaseComponent {
    constructor(title, container) {
        super(container);
        this.childComponents = [];
        this._title = title;
        BaseComponent_1.NexusGUIManager.registerComponent(this);
    }
    /**
     * 获取/设置分组标题
     */
    get title() {
        return this._title;
    }
    set title(v) {
        this._title = v;
        this.titleElement.textContent = v;
    }
    /**
     * 添加子组件
     */
    addChild(component) {
        if (!this.childComponents.includes(component)) {
            this.childComponents.push(component);
            // 将子组件的DOM元素移动到这个分组的内容区域
            if (component.domElement && component.domElement.parentNode) {
                component.domElement.parentNode.removeChild(component.domElement);
            }
            this.contentElement.appendChild(component.domElement);
        }
    }
    /**
     * 移除子组件
     */
    removeChild(component) {
        const index = this.childComponents.indexOf(component);
        if (index > -1) {
            this.childComponents.splice(index, 1);
            // 将子组件的DOM元素移回到默认容器
            if (component.domElement && component.domElement.parentNode) {
                component.domElement.parentNode.removeChild(component.domElement);
            }
            // 移回到原始容器
            const defaultContainer = BaseComponent_1.NexusGUIManager.getDefaultContainer();
            defaultContainer.appendChild(component.domElement);
        }
    }
    /**
     * 移除所有子组件
     */
    clearChildren() {
        // 复制数组避免在迭代时修改
        const children = [...this.childComponents];
        children.forEach(child => this.removeChild(child));
    }
    /**
     * 获取所有子组件
     */
    getChildren() {
        return [...this.childComponents];
    }
    /**
     * 获取内容容器
     */
    getContentContainer() {
        return this.contentElement;
    }
    createElement() {
        this.wrapperElement = document.createElement('div');
        this.titleElement = document.createElement('div');
        this.contentElement = document.createElement('div');
        this.element = this.wrapperElement;
    }
    render() {
        // 设置样式类
        this.wrapperElement.className = 'nexus-group';
        this.titleElement.className = 'nexus-group-title';
        this.contentElement.className = 'nexus-group-content';
        // 设置标题文本
        this.titleElement.textContent = this._title;
        // 组装DOM结构
        this.wrapperElement.appendChild(this.titleElement);
        this.wrapperElement.appendChild(this.contentElement);
        this.container.appendChild(this.wrapperElement);
    }
    /**
     * 销毁组件时同时销毁所有子组件
     */
    destroy() {
        this.clearChildren();
        super.destroy();
    }
}
exports.GroupComponent = GroupComponent;
/**
 * 水平布局组件
 * 提供水平排列的布局功能
 */
class HorizontalComponent extends BaseComponent_1.BaseComponent {
    constructor(gap = 8, container) {
        super(container);
        this.childComponents = [];
        this._gap = gap;
        BaseComponent_1.NexusGUIManager.registerComponent(this);
    }
    /**
     * 获取/设置子元素之间的间距
     */
    get gap() {
        return this._gap;
    }
    set gap(v) {
        this._gap = v;
        this.updateGap();
    }
    /**
     * 添加子组件
     */
    addChild(component) {
        if (!this.childComponents.includes(component)) {
            this.childComponents.push(component);
            // 将子组件的DOM元素移动到这个水平布局容器
            if (component.domElement && component.domElement.parentNode) {
                component.domElement.parentNode.removeChild(component.domElement);
            }
            this.wrapperElement.appendChild(component.domElement);
            // 更新间距
            this.updateGap();
        }
    }
    /**
     * 移除子组件
     */
    removeChild(component) {
        const index = this.childComponents.indexOf(component);
        if (index > -1) {
            this.childComponents.splice(index, 1);
            // 将子组件的DOM元素移回到默认容器
            if (component.domElement && component.domElement.parentNode) {
                component.domElement.parentNode.removeChild(component.domElement);
            }
            // 移回到原始容器
            const defaultContainer = BaseComponent_1.NexusGUIManager.getDefaultContainer();
            defaultContainer.appendChild(component.domElement);
            // 更新间距
            this.updateGap();
        }
    }
    /**
     * 移除所有子组件
     */
    clearChildren() {
        // 复制数组避免在迭代时修改
        const children = [...this.childComponents];
        children.forEach(child => this.removeChild(child));
    }
    /**
     * 获取所有子组件
     */
    getChildren() {
        return [...this.childComponents];
    }
    /**
     * 获取内容容器
     */
    getContentContainer() {
        return this.wrapperElement;
    }
    createElement() {
        this.wrapperElement = document.createElement('div');
        this.element = this.wrapperElement;
    }
    render() {
        // 设置样式类
        this.wrapperElement.className = 'nexus-horizontal';
        // 设置初始样式
        this.updateGap();
        // 添加到容器
        this.container.appendChild(this.wrapperElement);
    }
    /**
     * 更新子元素间距
     */
    updateGap() {
        if (!this.wrapperElement)
            return;
        // 设置CSS样式来控制子元素间距
        this.wrapperElement.style.display = 'flex';
        this.wrapperElement.style.gap = `${this._gap}px`;
        this.wrapperElement.style.alignItems = 'center';
    }
    /**
     * 销毁组件时同时销毁所有子组件
     */
    destroy() {
        this.clearChildren();
        super.destroy();
    }
}
exports.HorizontalComponent = HorizontalComponent;
